import { render, staticRenderFns } from "./DefaultBackend.vue?vue&type=template&id=2ef37d53&"
import script from "./DefaultBackend.vue?vue&type=script&lang=js&"
export * from "./DefaultBackend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports